<form nz-form [nzLayout]="'vertical'" nzSize="small" [formGroup]="form">
  <page-header auto-width-header [title]="titleTpl" [breadcrumb]="breadcrumb" [action]="actionTpl"
    [content]="contentTpl" [extra]="extra">
    <ng-template #breadcrumb>
      <nz-breadcrumb>
        <nz-breadcrumb-item>
          <a [routerLink]="['/']">Home</a>
        </nz-breadcrumb-item>
        <nz-breadcrumb-item>Sales</nz-breadcrumb-item>
        <nz-breadcrumb-item>
          <a [routerLink]="['/sale/do/list']">Delivery Orders</a>
        </nz-breadcrumb-item>
        <nz-breadcrumb-item>
          <span *ngIf="id === '0'">
            <i>&lt;---New---&gt;</i>
          </span>
          <span *ngIf="id !== '0'">
            <p nz-typography nzCopyable [nzContent]="dataSrv.code" class="d-inline-flex"></p>
          </span>
        </nz-breadcrumb-item>
      </nz-breadcrumb>
    </ng-template>
    <ng-template #titleTpl>
      Delivery Order
      <nz-tag nzColor="red" *ngIf="dataSrv._data.isCancelled" nz-tooltip [nzTooltipTitle]="voidTpl">
        CANCELLED
      </nz-tag>
      <nz-tag nzColor="blue" *ngIf="dataSrv._data.transferFrom" nz-tooltip
        [nzTooltipTitle]="dataSrv._data.transferFrom">
        TRANSF. FROM
      </nz-tag>
      <nz-tag nzColor="orange" *ngIf="dataSrv._data.transferStatus === 1" nz-tooltip
        [nzTooltipTitle]="dataSrv._data.transferTo">
        PARTIALLY TRANSFERRED
      </nz-tag>
      <nz-tag nzColor="green" *ngIf="dataSrv._data.transferStatus === 2" nz-tooltip
        [nzTooltipTitle]="dataSrv._data.transferTo">
        FULLY TRANSFERRED
      </nz-tag>
      <nz-tag nzColor="green" *ngIf="dataSrv._data.isClosed" nz-tooltip [nzTooltipTitle]="dataSrv._data.closedDate">
        CLOSED
      </nz-tag>
    </ng-template>
    <ng-template #actionTpl>
      <app-doc-edit-actions reportType="do-voucher" [additionalData]="{
        customerName: dataSrv.getValue('customerName')
      }">
      </app-doc-edit-actions>
    </ng-template>
    <ng-template #contentTpl>
      <span></span>

    </ng-template>

    <ng-template #extra>
      <app-auto-code formControlName="docCode" [isNew]="id === '0'" [date]="dataSrv.getValue('docDate')"
        [projectId]="dataSrv.getValue('projectId')" type="DO">
      </app-auto-code>
      <app-stk-posting-modal url="api/deliveryorders/StockPosting" [docId]="id"
        [docType]="'do'"></app-stk-posting-modal>
    </ng-template>
    <ng-template #voidTpl>
      <b>Cancellation Date:</b> {{ dataSrv._data.cancelledDate | customDate }}
      <br />
      <b>Reason:</b> {{ dataSrv._data.cancelledRemark }}
    </ng-template>
  </page-header>


  <!-- Row 1 -->
  <nz-row nzGutter="8">
    <!-- Col1 -->
    <nz-col nzXXl="10" nzXl="24" nzLg="24" nzMd="24" nzSm="24" nzXs="24">
      <!-- Customer Row -->
      <nz-row nzGutter="4">
        <nz-col nzLg="8" nzMd="8" nzSm="8" nzXs="10">
          <nz-form-item class="customer">
            <nz-form-label nzRequired="true" nzFor="customer">Customer</nz-form-label>
            <nz-input-group nzSearch [nzAddOnAfter]="infoBtn" class="width-100">
              <nz-form-control nzErrorTip="Customer is required">
                <app-customer-select app-auto-focus formControlName="customer" tabindex="1"
                  (ngModelChange)="onCustomerChange()"></app-customer-select>
              </nz-form-control>
            </nz-input-group>
            <ng-template #infoBtn>
              <button nz-button type="button" nz-tooltip nzTooltipTitle="More Info"
                [disabled]="!form.controls.customerId.value" (click)="openCustModal()">
                <span nz-icon nzType="info-circle" nzTheme="outline"> </span>
              </button>
            </ng-template>
          </nz-form-item>
        </nz-col>
        <nz-col nzLg="16" nzMd="16" nzSm="16" nzXs="14">
          <nz-form-item>
            <nz-form-label nzFor="customerName"></nz-form-label>
            <nz-form-control>
              <app-text-input #customerNameInput formControlName="customerName" maxlength="250"
                tabindex="2"></app-text-input>
            </nz-form-control>
          </nz-form-item>
        </nz-col>
      </nz-row>

      <!-- Currency & Rate & Term & Agent -->
      <nz-row nzGutter="8">
        <nz-col nzLg="8" nzMd="24" nzSm="24" nzXs="24">
          <nz-form-item>
            <nz-form-label nzFor="currencyRate">Currency Rate</nz-form-label>
            <nz-input-group nzSearch [nzAddOnAfter]="latestBtn" style="width:100%">
              <nz-form-control nzErrorTip="Currency rate is required">
                <app-currency-rate formControlName="currencyRate" required="true" tabindex="6"
                  [currency]="form.controls.currency.value">
                </app-currency-rate>
              </nz-form-control>
            </nz-input-group>
            <ng-template #latestBtn>
              <button nz-button nzType="default" type="button" (click)="updateLatestRate()"
                [disabled]="!dataSrv.editing || form.controls.currency.value?.local || dataSrv.updatingRate"
                [nzLoading]="dataSrv.updatingRate" nz-tooltip nzTooltipTitle="Click to retrieve latest currency rate">
                <span nz-icon nzType="search"></span>
              </button>
            </ng-template>
          </nz-form-item>
        </nz-col>
        <nz-col nzLg="8" nzMd="24" nzSm="24" nzXs="24">
          <nz-form-item>
            <nz-form-label nzFor="term" nzRequired>Term</nz-form-label>
            <nz-form-control nzErrorTip="Term is required">
              <app-term-select formControlName="term" tabindex="7"></app-term-select>
            </nz-form-control>
          </nz-form-item>
        </nz-col>
        <nz-col nzLg="8" nzMd="24" nzSm="24" nzXs="24" #inputWrapper data-control-name="agent">
          <nz-form-item>
            <nz-form-label nzFor="agent">Agent</nz-form-label>
            <nz-form-control nzErrorTip="Agent is required">
              <app-agent-select formControlName="agent" tabindex="8"></app-agent-select>
            </nz-form-control>
          </nz-form-item>
        </nz-col>
      </nz-row>
    </nz-col>
    <!-- Col2 -->
    <nz-col nzXXl="6" nzXl="10" nzLg="24" nzMd="24" nzSm="24" nzXs="24">
      <nz-form-item>
        <nz-form-label nzFor="billingAddress">Billing Address</nz-form-label>
        <nz-form-control>
          <app-memo-input formControlName="billingAddress" rows="5" maxlength="400" tabindex="3"></app-memo-input>
        </nz-form-control>
      </nz-form-item>
    </nz-col>
    <!-- Col3 -->
    <nz-col nzXXl="8" nzXl="14" nzLg="24" nzMd="24" nzSm="24" nzXs="24">
      <!-- Attention & Date -->
      <nz-row nzGutter="8">
        <nz-col nzLg="12" nzMd="24" nzSm="24" nzXs="24">
          <nz-form-item>
            <nz-form-label nzFor="attention">Attention</nz-form-label>
            <nz-form-control>
              <app-text-input formControlName="attention" maxlength="200" tabindex="4"></app-text-input>
            </nz-form-control>
          </nz-form-item>
        </nz-col>
        <nz-col nzLg="12" nzMd="24" nzSm="24" nzXs="24">
          <nz-form-item>
            <nz-form-label nzFor="date" nzRequired>Date</nz-form-label>
            <nz-form-control nzErrorTip="Transaction Date is required">
              <app-date-input formControlName="docDate" required allowClear="false" tabindex="5"></app-date-input>
            </nz-form-control>
          </nz-form-item>
        </nz-col>
      </nz-row>
      <nz-row nzGutter="8">

        <!-- Phone Col -->
        <nz-col nzLg="12" nzMd="24" nzSm="24" nzXs="24">
          <nz-form-item>
            <nz-form-label nzFor="customerPhone">Phone</nz-form-label><nz-form-control nzErrorTip="Phone  is required.">
              <app-text-input #phone1 formControlName="customerPhone" maxlength="100" app-mobile-input
                [allowDialCode]="true" [tabIndex]="9">
              </app-text-input>
            </nz-form-control>
          </nz-form-item>
        </nz-col>
        <!-- Phone Col End -->


      </nz-row>
    </nz-col>
  </nz-row>

  <!-- Row2 -->
  <nz-row nzGutter="8">
    <!-- Col1 -->
    <nz-col nzLg="10" nzMd="24" nzSm="24" nzXs="24">
      <nz-row nzGutter="8">
        <nz-col nzLg="16" nzMd="24" nzSm="24" nzXs="24">
          <nz-form-item>
            <nz-form-label nzFor="description">Description</nz-form-label>
            <nz-form-control>
              <app-text-input formControlName="description" maxlength="250" [tabIndex]="10"></app-text-input>
            </nz-form-control>
          </nz-form-item>
        </nz-col>
        <nz-col acl="m1.256" nzLg="8" nzMd="24" nzSm="24" nzXs="24" #inputWrapper data-control-name="project">
          <nz-form-item>
            <nz-form-label nzFor="project">Project</nz-form-label>
            <nz-form-control nzErrorTip="Project is required">
              <app-project-select formControlName="project" [tabIndex]="11">
              </app-project-select>
            </nz-form-control>
          </nz-form-item>
        </nz-col>
      </nz-row>
    </nz-col>
    <!-- Col2 -->
    <nz-col nzLg="6" nzMd="24" nzSm="24" nzXs="24">
      <nz-form-item>
        <nz-form-label nzFor="referenceNo">Ref No.</nz-form-label>
        <nz-form-control>
          <app-text-input formControlName="referenceNo" maxlength="50" [tabIndex]="12"></app-text-input>
        </nz-form-control>
      </nz-form-item>
    </nz-col>

    <!-- Col3 -->
    <nz-col nzLg="3" nzMd="24" nzSm="24" nzXs="24">
      <nz-form-item>
        <nz-form-label nzFor="isTaxInclusive"> Tax Inclusive </nz-form-label>
        <nz-form-control>
          <nz-switch formControlName="isTaxInclusive" tabindex="13" appFocusNzSwitch>
          </nz-switch>
        </nz-form-control>
      </nz-form-item>
    </nz-col>
    <!-- Col4
      <nz-col nzLg="2" nzMd="24" nzSm="24" nzXs="24" *ngIf="this.dataSrv.country === 'PH'">
        <nz-form-item>
          <nz-form-label nzFor="isDeferredTax">Deferred VAT</nz-form-label>
          <nz-form-control>
            <nz-switch formControlName="isDeferredTax"></nz-switch>
          </nz-form-control>
        </nz-form-item>
      </nz-col> -->
  </nz-row>

  <nz-row nzGutter="8">
    <nz-col nzLg="10" nzMd="24" nzSm="24" nzXs="24">
      <nz-row nzGutter="8">
        <nz-col [acl]="{ ability: ['m1.8', 'm1.64'], mode: 'allOf' }" nzLg="12" nzMd="24" nzSm="24" nzXs="24"
          #inputWrapper data-control-name="location">
          <nz-form-item>
            <nz-form-label nzFor="stockLocation">Stock Location</nz-form-label>
            <nz-form-control nzErrorTip="Stock Location is required">
              <app-stock-location-select formControlName="stockLocation" [tabIndex]="14">
              </app-stock-location-select>
            </nz-form-control>
          </nz-form-item>
        </nz-col>

        <!-- Col2 -->
        <nz-col nzLg="12" nzMd="24" nzSm="24" nzXs="24">
          <nz-form-item>
            <nz-form-label nzFor="deliveryTerm">Delivery Term</nz-form-label>
            <nz-form-control>
              <app-text-input formControlName="deliveryTerm" maxlength="50" [tabIndex]="15"></app-text-input>
            </nz-form-control>
          </nz-form-item>
        </nz-col>
      </nz-row>
    </nz-col>
  </nz-row>

  <nz-tabset [nzTabBarExtraContent]="toolguideTemplate">
    <ng-template #toolguideTemplate>
      <button nz-button class="toolguide-btn" type="button" (click)="toolguideModal.openModal()">
        Tool Guide
        <span nz-icon nzType="info-circle" nzTheme="outline"></span>
      </button>
    </ng-template>
    <nz-tab nzTitle="Details" nzSize="small" class="editable-table">

      <nz-button-group class="float-right text-primary mb-md">
        <!-- <div>
          <button type="button" nz-button nzType="primary" (click)="columnAdjustService.resetColumnOrder(visibleColumns, 'do')">
            Reset Column
          </button>
        </div> -->
        <app-col-options [columns]="columns" [layoutId]="'do-details'" #columnOption></app-col-options>

        <!-- Simple Pagination - Always Enabled -->
      </nz-button-group>

      <!-- Proper nz-table with Pagination -->
      <nz-table #itemDetailsTable formArrayName="itemDetails" [nzData]="getPaginatedData()" [nzFrontPagination]="false"
        [nzShowPagination]="false" nzBordered="true" nzSize="small" [nzScroll]="{ x: '600px', y: '600px' }">
        <thead>
          <tr cdkDropList cdkDropListOrientation="horizontal"
            (cdkDropListDropped)="columnAdjustService.drop($event,visibleColumns, 'do')">
            <th nzWidth="50px" [nzAlign]="'center'" *ngIf="dataSrv.editing"></th>
            <th nzWidth="48px" [nzAlign]="'center'">#</th>
            <ng-container *ngFor="let col of visibleColumns; let index = index; let last = last">
              <th [acl]="$any(col).acl" [nzWidth]="$any(col)?.width" nz-resizable nzPreview
                (nzResizeEnd)="onResize($event, col)" [nzAlign]="$any(col).align ?? 'left'" cdkDrag
                [cdkDragDisabled]="col.key === 'stock'">
                <nz-resize-handle *ngIf="!last" nzDirection="right">
                  <i></i>
                </nz-resize-handle>
                <div class="th-drag-preview" *cdkDragPreview>{{ $any(col.title).text ?? col.title }}</div>
                <ng-container>
                  <div cdkDragHandle>
                    <span [innerHTML]="$any(col.title).text ?? col.title"></span>
                    @if ($any(col.title).optional) {
                    <small class="st__head-optional" [innerHTML]="$any(col.title).optional"></small>
                    }
                    @if ($any(col.title).optionalHelp) {
                    <i class="st__head-tip" nz-tooltip [nzTooltipTitle]="$any(col.title).optionalHelp" nz-icon
                      nzType="question-circle"></i>
                    }
                  </div>
                </ng-container>
              </th>
            </ng-container>
            <th nzWidth="50px" [nzAlign]="'center'" *ngIf="dataSrv.editing"></th>
          </tr>
        </thead>
        <tbody cdkDropList [cdkDropListData]="getPaginatedData()" (cdkDropListDropped)="onDropLine($event)"
          class="edit-table">
          <tr *ngFor="let line of getPaginatedData(); trackBy: trackByRow; let i = index" cdkDrag
            [cdkDragDisabled]="!dataSrv.editing || line.value.isSubItem" [cdkDragData]="line" [formGroupName]="getGlobalIndex(i)"
            [ngClass]="{ 'bundle-header': line.value.isBundled && !line.value.isSubItem, 'bundle-sub-item': line.value.isSubItem }"
            [style.height]="(line.value.stock && line.value.description) ? null : '0px !important'">
            <td class="text-center" *ngIf="dataSrv.editing">
              <span nz-icon nzType="drag" nzTheme="outline" class="drag-icon" cdkDragHandle *ngIf="!line.value.isSubItem"></span>
            </td>
            <td class="text-center">{{ line.value.numbering }}</td>
            @for (col of visibleColumns; track col.key) {
            <td #editableCell [attr.data-row]="i" [attr.data-column]="col.name"
              [nzAlign]="col.align === undefined ? null : col.align">
              @switch (col.name) {
              @case ('stock') {
              <app-stock-select #stockSelections formControlName="stock" valueField="" labelField="code"
                [borderless]="true"
                [allowEdit]="(!line.value.transferFromQuotationDetailId || !line.value.transferFromSalesOrderDetailId) && !line.value.isSubItem"
                (keydown)="onKeyDown($event, getGlobalIndex(i), 'stock')"
                (onOpenChange)="$event && (recentStockControlIndex = getGlobalIndex(i))">
                >

              </app-stock-select>
              }
              @case ('project') {
              <app-project-select formControlName="project" [borderless]="true"
                [allowEdit]="line.value.stockId && !form.controls.projectId.value && !(line.value.isBundled && !line.value.isSubItem)"
                (keydown)="onKeyDown($event, getGlobalIndex(i), 'project')">
              </app-project-select>
              }
              @case ('classification') {
              <app-einvoice-stock-classification-select formControlName="classification" [borderless]="true"
                [allowEdit]="line.value.stockId">
              </app-einvoice-stock-classification-select>
              }
              @case ('desc') {
              <app-text-input formControlName="description" maxlength="250" [borderless]="true"
                (keydown)="onKeyDown($event, getGlobalIndex(i), 'desc')">
              </app-text-input>
              }
              @case ('fDesc') {
              <button type="button" nz-button nzType="text" nzSize="small" nzShape="round"
                (click)="fDescriptionModal(line)" class="fdesc-btn" [disabled]="!dataSrv.editing"
                [style.display]="!dataSrv.editing &&(!line.value.stock || !line.value.description)?'none':''">
                <span nz-icon nzType="edit" nzTheme="outline"></span>
              </button>
              }
              @case ('qty') {
              <app-qty-input formControlName="qty" [borderless]="true" [allowEdit]="line.value.stockId"
                [ignoreZero]="true" [tranxType]="'sales'" (changing)="validateRemainingQty($event, line.value)"
                (keydown)="onKeyDown($event, getGlobalIndex(i), 'qty')">
              </app-qty-input>
              }
              @case ('uom') {
              <app-uom-select formControlName="uom" [stockId]="line.value.stockId" [borderless]="true"
                [allowEdit]="line.value.stockId &&(!line.value.transferFromQuotationDetailId ||!line.value.transferFromSalesOrderDetailId)"
                (keydown)="onKeyDown($event, getGlobalIndex(i), 'uom')">
              </app-uom-select>
              }
              @case ('unitPrice') {
              <app-currency-input formControlName="unitPrice" [borderless]="true" [allowEdit]="line.value.stockId"
                [ignoreZero]="true" [tranxType]="'sales'" [allowNegative]="true"
                (keydown)="onKeyDown($event, getGlobalIndex(i), 'unitPrice')"
                [protected]="acl.can({ ability: ['do.hideUnitCost'] })">
              </app-currency-input>
              }
              @case ('discount') {
              <app-discount-input formControlName="discount" [allowEdit]="line.value.stockId" [maxLength]="50"
                [borderless]="true" (keydown)="onKeyDown($event, getGlobalIndex(i), 'discount')">
              </app-discount-input>
              }
              @case ('discountAmount') {
              <app-currency-input formControlName="discountAmount" [allowEdit]="false" [borderless]="true"
                [ignoreZero]="true">
              </app-currency-input>
              }
              @case ('amount') {
              <app-currency-input formControlName="amount" [borderless]="true" [allowEdit]="false" [ignoreZero]="true"
                [allowNegative]="true">
              </app-currency-input>
              }
              @case ('netAmount') {
              <app-currency-input formControlName="netAmount" [borderless]="true" [allowEdit]="false"
                [ignoreZero]="true" [allowNegative]="true" />
              }
              @case ('ref1') {
              <app-text-input formControlName="ref1" maxlength="200" [borderless]="true"
                (keydown)="onKeyDown($event, getGlobalIndex(i), 'ref1')" />
              }
              @case ('ref2') {
              <app-text-input formControlName="ref2" maxlength="200" [borderless]="true"
                (keydown)="onKeyDown($event, getGlobalIndex(i), 'ref2')" />
              }
              @case ('dateRef1') {
              <app-date-input formControlName="dateRef1" [borderless]="true" [nzAllowClear]="true"
                (keydown)="onKeyDown($event, getGlobalIndex(i), 'dateRef1')" />
              }
              @case ('dateRef2') {
              <app-date-input formControlName="dateRef2" [borderless]="true" [nzAllowClear]="true"
                (keydown)="onKeyDown($event, getGlobalIndex(i), 'dateRef2')" />
              }
              @case ('stockLocation') {
              <app-stock-location-select formControlName="stockLocation" [borderless]="true"
                [allowEdit]="line.value.stockId && !form.controls.stockLocationId.value && !(line.value.isBundled && !line.value.isSubItem)"
                (keydown)="onKeyDown($event, getGlobalIndex(i), 'stockLocation')">
              </app-stock-location-select>
              }
              @case ('taxCode') {
              <app-output-tax-code-select formControlName="taxCode" valueField="" [borderless]="true"
                [allowEdit]="line.value.stockId && !(line.value.isBundled && !line.value.isSubItem)" (keydown)="onKeyDown($event, getGlobalIndex(i), 'taxCode')"
                (openChange)="$event && (recentTaxControlIndex = getGlobalIndex(i))">
              </app-output-tax-code-select>
              }
              @case ('taxAmount') {
              <app-currency-input formControlName="taxAmount" [borderless]="true" [allowEdit]="false"
                [ignoreZero]="true" [allowNegative]="true">
              </app-currency-input>
              }
              @case ('taxExemptionRate') {
              <app-taxcode-exemptionrate-select formControlName="taxExemptionRate" [borderless]="true"
                [allowEdit]="line.value.stockId && line.value.taxCodeId"
                [govTaxCode]="line.value.taxCode?.govTaxCode ?? ''" />
              }
              @case ('taxExemptionAmount') {
              <app-currency-input formControlName="taxExemptionAmount" [borderless]="true" [allowEdit]="false"
                [ignoreZero]="true" />
              }
              @case ('taxAmountAdjustment') {
              <app-currency-input formControlName="taxAmountAdjustment" [borderless]="true"
                [allowEdit]="!!line.value.taxCode" [ignoreZero]="true" [allowNegative]="true"
                (keydown)="onKeyDown($event, getGlobalIndex(i), 'taxAmountAdjustment')">
              </app-currency-input>
              }
              @case ('rentalLeaseExemptedRate') {
              <app-percent-input formControlName="rentalLeaseExemptedRate" [borderless]="true"
                [allowEdit]="false" />
              }
              @case ('rentalLeaseExemptedTaxAmount') {
              <app-currency-input formControlName="rentalLeaseExemptedTaxAmount" [borderless]="true"
                [allowEdit]="false" [ignoreZero]="true" [allowNegative]="true" />
              }
              @case ('tariffCode') {
              <app-tariff-tax-code-select formControlName="tariffCode" [borderless]="true"
                [allowEdit]="line.value.stockId" (keydown)="onKeyDown($event, getGlobalIndex(i), 'tariffCode')" />
              }
              @case ('taxExemptionDetails') {
              <app-number-only-input formControlName="taxExemptionDetails" [maxChar]="300" [borderless]="true"
                [allowDot]="true" [allowEdit]="line.value.stockId"
                [style.display]="!dataSrv.editing && (!line.value.stock || !line.value.description) ? 'none' : ''">
              </app-number-only-input>
              }
              @case ('netAmount') {
              <app-currency-input formControlName="netAmount" [borderless]="true" [allowEdit]="false"
                [ignoreZero]="true" [allowNegative]="true">
              </app-currency-input>
              }
              @case ('tariffCode') {
              <app-tariff-tax-code-select formControlName="tariffCode" [borderless]="true"
                [allowEdit]="line.value.stockId && !(line.value.isBundled && !line.value.isSubItem)">
              </app-tariff-tax-code-select>
              }
              @case ('taxExemptNo') {
              <app-text-input formControlName="taxExemptionNo" maxlength="20" [borderless]="true"
                [allowEdit]="line.value.stockId" (keydown)="onKeyDown($event, getGlobalIndex(i), 'taxExemptNo')">
              </app-text-input>
              }
              @case ('wTaxCode') {
              <app-output-wtax-code-select formControlName="wTaxCode" [borderless]="true"
                [allowEdit]="line.value.stockId && !(line.value.isBundled && !line.value.isSubItem)" (keydown)="onKeyDown($event, getGlobalIndex(i), 'wTaxCode')">
              </app-output-wtax-code-select>
              }
              @case ('wTaxAmount') {
              <app-currency-input formControlName="wTaxAmount" [borderless]="true" [allowEdit]="false"
                [ignoreZero]="true" [allowNegative]="true">
              </app-currency-input>
              }
              @case ('wTaxAmountAdjustment') {
              <app-currency-input formControlName="wTaxAmountAdjustment" [borderless]="true"
                [allowEdit]="line.value.wTaxCode" [ignoreZero]="true" [allowNegative]="true"
                (keydown)="onKeyDown($event, getGlobalIndex(i), 'wTaxAmountAdjustment')">
              </app-currency-input>
              }
              @case ('wVatCode') {
              <app-wtax-code-select formControlName="wVatCode" [wvatOnly]="true" [borderless]="true"
                [allowEdit]="line.value.accountId">
              </app-wtax-code-select>
              }
              @case ('wVatRate') {
              <app-currency-input formControlName="wVatRate" [borderless]="true" [allowEdit]="false"
                [ignoreZero]="true">
              </app-currency-input>
              }
              @case ('wVatAmount') {
              <app-currency-input formControlName="wVatAmount" [borderless]="true" [allowEdit]="false"
                [ignoreZero]="true">
              </app-currency-input>
              }
              @case ('account') {
              <app-gl-acc-select formControlName="account" valueField="" labelField="code" [borderless]="true"
                [allowEdit]="line.value.stockId">
              </app-gl-acc-select>
              }
              @case ('referenceNo') {
              <app-text-input formControlName="referenceNo" [maxlength]="50" [borderless]="true"
                (keydown)="onKeyDown($event, getGlobalIndex(i), 'referenceNo')">
              </app-text-input>
              }
              @case ('stockCategoryCode') {
              {{ line.value.stock?.category?.code }}
              }
              @case ('stockGroupCode') {
              {{ line.value.stock?.group?.code }}
              }
              @case ('stockClassCode') {
              {{ line.value.stock?.class?.code }}
              }
              @case ('stockAlternateName') {
              {{ line.value.stock?.description }}
              }
              @case ('minPrice') {
              <app-currency-input [value]="line.value.stock?.minPrice" [borderless]="true" [allowEdit]="false"
                [ignoreZero]="true" [allowNegative]="true" [protected]="acl.can({ ability: ['do.hideUnitCost'] })">
              </app-currency-input>
              }
              @case ('lastSellingPrice') {
              <app-currency-input [value]="line.value.stock?.lastSellingPrice" [borderless]="true" [allowEdit]="false"
                [ignoreZero]="true" [allowNegative]="true" [protected]="acl.can({ ability: ['do.hideUnitCost'] })">
              </app-currency-input>
              }
              @case ('lastPurchasePrice') {
              <app-currency-input [value]="line.value.stock?.lastPurchasePrice" [borderless]="true" [allowEdit]="false"
                [ignoreZero]="true" [allowNegative]="true" [protected]="acl.can({ ability: ['so.hideUnitCost'] })">
              </app-currency-input>
              }
              }
            </td>
            }
            <td class="text-center" *ngIf="dataSrv.editing">
              <!-- <a nz-popconfirm nzPopconfirmTitle="Are you sure to remove this item?"
                (nzOnConfirm)="removeLineAtGlobalIndex(getGlobalIndex(i))">
                <span nz-icon nzType="delete" nzTheme="outline"></span>
              </a> -->
              <a (click)="removeLineAtGlobalIndex(getGlobalIndex(i))">
                <span nz-icon nzType="delete" nzTheme="outline"></span>
              </a>
            </td>
          </tr>
        </tbody>
      </nz-table>

      <!-- Pagination Controls - Under Table -->
      <div class="pagination-container" *ngIf="totalRowCount > 0">
        <div class="pagination-wrapper">
          <!-- Summary Text -->
          <div class="pagination-summary">
            {{ getPaginationSummary() }}
          </div>

          <!-- Page Navigation -->
          <div class="pagination-nav">
            <button type="button" nz-button nzType="text" [disabled]="currentPage === 1" (click)="prevPage()"
              class="nav-btn prev-btn">
              <span nz-icon nzType="left"></span>
            </button>

            <div class="page-numbers">
              @for (page of getPageNumbers(); track page) {
              @if (page === '...') {
              <span class="page-ellipsis">...</span>
              } @else {
              <button type="button" nz-button nzType="text" [nzSize]="'small'"
                [class.active-page]="page === currentPage" (click)="goToPage(+page)" class="page-number">
                {{ page }}
              </button>
              }
              }
            </div>

            <button type="button" nz-button nzType="text" [disabled]="currentPage === totalPages" (click)="nextPage()"
              class="nav-btn next-btn">
              <span nz-icon nzType="right"></span>
            </button>
          </div>

          <!-- Items per page selector -->
          <div class="items-per-page">

            <!-- Fallback simple select -->
            <select [(ngModel)]="pageSize" [ngModelOptions]="{standalone: true}"
              (change)="onPageSizeChange($any($event.target).value)">
              <option value="10" [selected]="pageSize === 10">10 / page</option>
              <option value="20" [selected]="pageSize === 20">20 / page</option>
              <option value="50" [selected]="pageSize === 50">50 / page</option>
            </select>

          </div>
        </div>
      </div>

      <!-- Add Lines Button -->
      <button type="button" nz-button [nzType]="'dashed'" (click)="addLines()" nzBlock class="mt-md"
        *ngIf="dataSrv.editing">
        <i nz-icon nzType="plus"></i>
        <span>Add Lines</span>
      </button>
    </nz-tab>
    <nz-tab nzTitle="DO Address">
      <nz-row nzGutter="8">
        <nz-col nzLg="8" nzMd="12" nzSm="24" nzXs="24">
          <nz-form-item>
            <nz-form-label nzFor="doBranchCode">Branch #</nz-form-label>
            <nz-form-control>
              <app-do-address-select formControlName="doBranchCode" [customerId]="form.value.customerId"
                (valueChanged)="populateDOAddress($event)" class="branch-field">
              </app-do-address-select>
            </nz-form-control>
          </nz-form-item>
          <nz-form-item>
            <nz-form-label nzFor="doAddress">Delivery Address</nz-form-label>
            <nz-form-control>
              <textarea title="DO Address" nz-input formControlName="doAddress" rows="5" maxlength="400"></textarea>
            </nz-form-control>
          </nz-form-item>
        </nz-col>
        <nz-col nzLg="8" nzMd="12" nzSm="24" nzXs="24">
          <nz-form-item>
            <nz-form-label nzFor="doBranchName">Branch Name</nz-form-label>
            <nz-form-control>
              <app-text-input formControlName="doBranchName" maxlength="250"></app-text-input>
            </nz-form-control>
          </nz-form-item>
          <nz-form-item>
            <nz-form-label nzFor="doContact">Contact</nz-form-label>
            <nz-form-control>
              <app-text-input formControlName="doContact" maxlength="200"></app-text-input>
            </nz-form-control>
          </nz-form-item>
          <nz-form-item>
            <nz-form-label nzFor="doPhoneNo">Phone No.</nz-form-label>
            <nz-form-control>
              <app-text-input formControlName="doPhoneNo" maxlength="100" app-mobile-input [allowDialCode]="true"
                [allowParentheses]="true">
              </app-text-input>
            </nz-form-control>
          </nz-form-item>
          <nz-form-item>
            <nz-form-label nzFor="doFaxNo">Fax No.</nz-form-label>
            <nz-form-control>
              <app-text-input formControlName="doFaxNo" maxlength="100" app-mobile-input [allowDialCode]="true"
                [allowParentheses]="true">
              </app-text-input>
            </nz-form-control>
          </nz-form-item>
        </nz-col>
      </nz-row>
    </nz-tab>
    <nz-tab nzTitle="Others">
      <nz-row nzGutter="8">
        <nz-col nzLg="8" nzMd="12" nzSm="24" nzXs="24">
          <nz-form-item>
            <nz-form-label nzFor="ref1">Reference 1</nz-form-label>
            <nz-form-control>
              <app-text-input formControlName="ref1" maxlength="50"></app-text-input>
            </nz-form-control>
          </nz-form-item>
          <nz-form-item>
            <nz-form-label nzFor="ref2">Reference 2</nz-form-label>
            <nz-form-control>
              <app-text-input formControlName="ref2" maxlength="50"></app-text-input>
            </nz-form-control>
          </nz-form-item>
          <nz-form-item>
            <nz-form-label nzFor="ref3">Reference 3</nz-form-label>
            <nz-form-control>
              <app-text-input formControlName="ref3" maxlength="50"></app-text-input>
            </nz-form-control>
          </nz-form-item>
          <nz-form-item>
            <nz-form-label nzFor="ref4">Reference 4</nz-form-label>
            <nz-form-control>
              <app-text-input formControlName="ref4" maxlength="50"></app-text-input>
            </nz-form-control>
          </nz-form-item>
        </nz-col>
        <nz-col nzLg="8" nzMd="12" nzSm="12" nzXs="24">
          <nz-form-item>
            <nz-form-label nzFor="remark1">Remark 1</nz-form-label>
            <nz-form-control>
              <app-text-input formControlName="remark1" maxlength="100"></app-text-input>
            </nz-form-control>
          </nz-form-item>
          <nz-form-item>
            <nz-form-label nzFor="remark2">Remark 2</nz-form-label>
            <nz-form-control>
              <app-text-input formControlName="remark2" maxlength="100"></app-text-input>
            </nz-form-control>
          </nz-form-item>
          <nz-form-item>
            <nz-form-label nzFor="remark3">Remark 3</nz-form-label>
            <nz-form-control>
              <app-text-input formControlName="remark3" maxlength="100"></app-text-input>
            </nz-form-control>
          </nz-form-item>
          <nz-form-item>
            <nz-form-label nzFor="remark4">Remark 4</nz-form-label>
            <nz-form-control>
              <app-text-input formControlName="remark4" maxlength="100"></app-text-input>
            </nz-form-control>
          </nz-form-item>
        </nz-col>
      </nz-row>
    </nz-tab>
    <nz-tab [nzTitle]="AttachmentsTittle">
      <ng-template #AttachmentsTittle>
        <nz-badge class="attachment-badge" [nzCount]="attachmentTable.attachmentCount" [nzOffset]="[7,2]"
          [nzSize]="'small'">
          <div>
            Attachments
          </div>
        </nz-badge>
      </ng-template>
      <app-attachment-table #attachmentTable [eventTriggered]="dataSrv.eventTrigger" [referenceId]="id" [type]="['Do']"
        [disabled]="!dataSrv.editing" [deferSave]="true"></app-attachment-table>
    </nz-tab>
    <nz-tab [nzTitle]="TabTittle">
      <ng-template #TabTittle>
        <div>
          Notes
          <span *ngIf="form.controls.notes.value">...</span>
        </div>
      </ng-template>
      <nz-row>
        <nz-col nzSpan="24">
          <nz-form-item>
            <nz-form-control>
              <textarea #notesTextArea title="Notes" nz-input formControlName="notes" rows="4"
                maxlength="500"></textarea>
            </nz-form-control>
          </nz-form-item>
        </nz-col>
        <nz-col nzSpan="24">
          <button type="button" nz-button (click)="timestamp()" [disabled]="!dataSrv.editing">
            <span nz-icon nzType="plus" nzTheme="outline"></span> TimeStamp
          </button>
        </nz-col>
      </nz-row>
    </nz-tab>
  </nz-tabset>
</form>
<nz-divider></nz-divider>
<app-tranx-summary #tranxSummary [showDeposit]="true" [depositInfo]="{
    editable: dataSrv.editing && (dataSrv._data.isDepositEditable ?? true),
    groupInfo: dataSrv._data.depositInfo
  }" [currency]="form.controls.currency.value?.code" [totalAmount]="form.controls.totalAmount.value"
  [amountExemptedFromTax]="form.controls.amountExemptedFromTax.value"
  [taxExemptionTotalAmount]="form.controls.taxExemptionTotalAmount.value"
  [taxable]="form.controls.taxExclusiveTotalAmount.value" [taxAmount]="form.controls.taxTotalAmount.value"
  [wtaxAmount]="form.controls.wTaxTotalAmount.value" [netTotalAmount]="form.controls.netTotalAmount.value"
  [totalDiscount]="form.controls.discountTotalAmount.value" [hideTotal]="true"
  [protected]="acl.can({ ability: ['do.hideUnitCost'] })">
</app-tranx-summary>

<app-customer-info-modal #custModal> </app-customer-info-modal>
<app-toolguide-modal #toolguideModal></app-toolguide-modal>